'use client';

import { c as _c } from "react/compiler-runtime";
import { Provider } from 'jotai';
import { store } from './store';
export type JotaiProviderProps = {
  children: React.ReactNode;
};
export function JotaiProvider(t0) {
  const $ = _c(2);
  const {
    children
  } = t0;
  let t1;
  if ($[0] !== children) {
    t1 = <Provider store={store}>{children}</Provider>;
    $[0] = children;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}